import { GetterTree } from 'vuex'
import { SpirApplication, SpirApplicationsState } from '@/store/applications/spir/types'
import { RootState } from '@/store/types'

const getters : GetterTree<SpirApplicationsState, RootState> = {
  /**
   * 申請IDを元にSPIR申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {SpirApplication|null} 申請情報
   */
  findSpirApplicationById: (state) => (applicationId: string): SpirApplication|null => {
    return state.applications.find((app: SpirApplication) => app.id === applicationId) || null
  },
}

export default getters
